export type CodeLibrary = {
  id: string;
  name: string;
  isActive?: boolean;

  // merging 2 backend models
  fieldId?: string;
  fieldAlias?: string;
  fieldLabel?: string;
  fieldTemplateId?: string;
  formTemplateLabel?: string;

  // only used in the project, not coming from the server
  isInternal?: boolean;
  config?: {
    displayName?: {
      hu: string;
      en: string;
    };
    optionFormat?: OptionFormat;
  };
};

export enum OptionFormat {
  title = 'TITLE',
  idAndTitle = 'ID_AND_TITLE',
}

export type CodeLibraryOption = {
  id: string;
  name: string;
  isActive: boolean;
  externalId: string;
  meta: {
    activeSubstance: string;
    atc: string;
    code: string;
    ttt: string;
    _id: string;
  };
  validityStart: string;
  validityEnd: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  codeLibrary: CodeLibrary;
};

export type ProjectCodeLibrary = {
  fieldId: string;
  fieldAlias: string;
  fieldLabel: string;
  fieldTemplateId: string;
  formTemplateLabel: string;
};
